import { StripeMetaService } from './stripe-meta.service';
import { ErrorService } from '../../general/error.service';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

@Injectable({
  providedIn: 'root'
})
export class StripeSessionService implements OnInit, OnDestroy {

  constructor(
    private fns: AngularFireFunctions,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  async retrieveSessionCall(debugMode: boolean, currency: string, sessionId: string) {
    if (currency && sessionId) {
      return await this.fns.httpsCallable('stripeRetrieveSessionCall')({
        debugMode,
        currency,
        sessionId,
      }).toPromise().then(async (session: any) => {
        return session;
      }).catch((err: any) => {
        this.errorService.logError(err);
        return null;
      });
    } else {
      return null;
    }
  }
}
